<template>
  <div>
    <el-container>
      <el-header>
        <el-row>
          <el-col :span="20" :offset="1"><el-input v-model="val" :placeholder="placeholder"></el-input></el-col>
          <el-col :span="3"><el-button @click="addIP">添加</el-button></el-col>
        </el-row>
      </el-header>
      <el-main class="main-body">
        <pg-mainshell :h1Title="h1Title">
          <el-row class="white-list">
            <el-col :span="8" v-for="(item,index) in list" :v-if="true" :key="index">
              <div class="grid-content" v-if="Math.floor(index/3)%2 == 0">
                <span>{{item}}</span>
                <img :src="delsvg" alt="" @click="delIP(index)">
              </div>
              <div class="grid-content light" v-else>
                <span>{{item}}</span>
                <img :src="delsvg" alt="" @click="delIP(index)">
              </div>
            </el-col>
          </el-row>
        </pg-mainshell>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import PgMainshell from '../../components/PgMainShell'
import delsvg from '../../assets/img/del.svg'
import constant from '../../utils/constant'
import $ from 'jquery'

export default {
  data () {
    return {
      h1Title: '白名单',
      val: '',
      placeholder: '输入IP，多个IP用英文符号“,”隔开',
      list: [],
      liststr: '',
      hoverColor: '',
      delsvg: delsvg
    }
  },
  components: {
    PgMainshell
  },
  methods: {
    initData () {
      let that = this
      this.$api.whitelist.getIpAddressApi()
        .then(function (res) {
          if (!res.data.data) {
            that.liststr = ''
            that.list = []
          } else {
            that.liststr = res.data.data
            that.list = res.data.data.split(',')
          }
        })
        .catch(function (err) {
          console.log(err)
          constant.giveMessage('Error！', 'error')
        })
    },
    addIP () {
      let info = {
        message: '添加成功！',
        type: 'success'
      }

      if (!this.val) {
        info = {
          message: 'IP不能为空！',
          type: 'error'
        }
      } else if (this.list.indexOf(this.val) > -1) { // 单个IP相同情况
        info = {
          message: 'IP已存在！',
          type: 'error'
        }
      } else if (!this.checkIsIps(this.val)) {
        info = {
          message: '输入字符串不为IP，请确认格式！',
          type: 'error'
        }
      } else {
        if (this.val.indexOf(',') > -1) { // 存在多个IP
          let tmpArr = this.val.split(',')
          for (let item in tmpArr) {
            // 是否存在
            if (this.list.indexOf(tmpArr[item]) === -1) {
              this.list.push(tmpArr[item])
            }
          }
        } else { // 单个IP
          this.list.push(this.val)
        }
        this.liststr = ''
        this.list.map(x => {
          this.liststr = this.liststr + ',' + x
        })
        this.liststr = this.liststr.substring(1)
      }
      this.setIpAddressApi()
      // 接口使用覆盖前值的方式实现新增
      constant.giveMessage(info.message, info.type)
    },
    checkIsIps (ips) {
      var reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
      var valdata = ips.split(',')
      for (let i = 0; i < valdata.length; i++) {
        if (reg.test(valdata[i]) === false) {
          return false
        }
      }
      return true
    },
    setIpAddressApi () {
      let that = this
      this.$api.whitelist.setIpAddressApi({apiPlatformIpAddress: that.liststr})
        .then(function (res) {
        })
        .catch(function (err) {
          console.log(err)
          constant.giveMessage('Error！', 'error')
        })
    },
    delIP (index) {
      this.list.splice(index, 1)
      this.liststr = ''
      this.list.map(x => {
        this.liststr = this.liststr + ',' + x
      })
      this.liststr = this.liststr.substring(1)
      this.setIpAddressApi()
      // 接口使用覆盖前值的方式实现删除
      constant.giveMessage('删除成功！', 'success')
    },
    hover (index) {
      let _self = $('.main-body .el-row')
      // hover记住原色
      _self.find('.el-col').hover(function () {
        this.hoverColor = $(this).css('background-color')
        $(this).css('background-color', '#354ECE14')
        $(this).find('.grid-content>img').css('display', 'block')
        // 初始化
        this.hoverColor = ''
      }, function () {
        $(this).css('background-color', this.hoverColor)
        $(this).find('.grid-content>img').css('display', 'none')
        this.hoverColor = ''
      })
    }
  },
  created: function () {
    this.initData()
    if (this.liststr.length !== 0) {
      this.list = this.liststr.split(',')
    }
  },
  mounted: function () {
    // 最后一个元素初次加载补齐右边框
    $('.main-body >>> .el-col:nth-last-child(1)').css('border-right', '1px solid #E0E7EE')
    this.hover()
  },
  updated: function () {
    // 判断是否mod3，补足右侧边框问题
    let length = this.list.length
    switch (length % 3) {
      case 1:
        $('.white-list').children().eq(length - 1).css('border-right', '1px solid #E0E7EE')
        break
      case 2:
        $('.white-list').children().eq(length - 1).css('border-right', '1px solid #E0E7EE')
        break
      case 0:
        $('.white-list').children().eq(length - 2).css('border-right', 'none')
        break
      default:
        break
    }
    $('.main-body >>> .el-col:nth-child(3n)').css('border-right', '1px solid #E0E7EE')
    this.hover(length)
  }
}
</script>

<style scoped>
.main-body>div{
  height: clac(100% - 42px - 35px);
}
.el-container>.el-container>.el-main>div{
  height: 100%;
}
.el-container {
  padding: 42px 58px 35px 0;
  background: #F7F8F9;
  height: 100%;
}
.el-header {
  width: 100%;
  height: 100px !important;
  background-color: #FFFFFF;
  color: #333;
  text-align: center;
  line-height: 60px;
  margin-bottom: 24px;
  padding: 33px 0;
}
.el-header .el-row{
  display:flex;
  justify-content: center;
  align-items: center;
}
.el-header .el-row .el-col,.el-header .el-row .el-col /deep/ .el-input__inner{
  height: 34px;
  line-height: 34px;
}
.el-header .el-row .el-col /deep/ .el-input__inner{
  border: 1px solid #E0E7EE;
}
.el-input{
  height: 34px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #E0E7EE;
  border-radius: 4px;
  opacity: 1;
}
.el-header .el-button{
  width: 90px;
  height: 34px;
  line-height: 10px;
  background: #354ECE 0% 0% no-repeat padding-box;
  border-radius: 6px;
  font: Regular 14px/25px Microsoft YaHei;
  letter-spacing: 0;
  color: #FFFFFF;
}
.main-body {
  width: 100%;
  background-color: #FFFFFF;
  color: #333;
  text-align: center;
  line-height: 160px;
  padding: 0 0 0 28px;
}
.main-body /deep/ .body-content{
  background: #fff;
}
.main-body /deep/ h1{
  font-size: 18px !important
}

.main-body /deep/ .grid-content{
  height: 14px;
  line-height: 14px;
}
.main-body /deep/ .el-col:nth-child(3n){
  border-right: 1px solid #E0E7EE;
}
.main-body /deep/ .el-col:nth-child(6n+4),
.main-body /deep/ .el-col:nth-child(6n+5),
.main-body /deep/ .el-col:nth-child(6n+6)
{
  background: #FAFBFC
}
.main-body /deep/ .el-col:nth-last-child(1),
.main-body /deep/ .el-col:nth-last-child(2),
.main-body /deep/ .el-col:nth-last-child(3){
  border-bottom: 1px solid #E0E7EE;
}
.main-body /deep/ .el-col{
  background: #FFFFFF;
  height: 40px;
  line-height: 40px;
  border-left: 1px solid #E0E7EE;
  border-top: 1px solid #E0E7EE;
  padding: 13px 35px;
}
.grid-content{
  position: relative;
}
.grid-content>img{
  float: right;
  display: none;
  position: absolute;
  top: 0;
  right: 0;
}
.grid-content>span{
  float: left;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/containers/Whitelist/Index.vue